import type { IOpenClosedCounts, IRecordStats, IStatusSet } from '@platform/core/types';

/** Усього / відкриті / закриті за статистикою `by=status`: закритими вважаються відра зі статусами `closed` у визначенні. */
export function openClosedOf(stats: IRecordStats | undefined, statuses: IStatusSet): IOpenClosedCounts {
  const total = stats?.total ?? 0;
  const closedValues = new Set(statuses.list.filter((s) => s.closed).map((s) => s.value));
  const closed = (stats?.buckets ?? []).filter((b) => b.value !== null && closedValues.has(b.value)).reduce((sum, b) => sum + b.count, 0);
  return { total, open: Math.max(0, total - closed), closed };
}
